var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.url,"width":"100%","height":"100%","allow":"camera;microphone;fullscreen;display-capture;"}})
}
var staticRenderFns = []

export { render, staticRenderFns }